const PaymentTaskIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.5 17.5021C6.5 18.3324 7.09881 19 7.83334 19H9.33432C9.97304 19 10.492 18.418 10.492 17.6904C10.492 16.9116 10.1727 16.6291 9.7016 16.4494L7.2984 15.5506C6.82734 15.3709 6.50799 15.097 6.50799 14.3096C6.50799 13.5906 7.02694 13 7.66566 13H9.16666C9.90119 13 10.5 13.6676 10.5 14.4979"
      stroke="#447AED"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.5 12V20"
      stroke="#447AED"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.5 9.49729V7.48904C7.5 6.61785 7.5 6.18193 7.66349 5.84918C7.8073 5.55648 8.0366 5.31868 8.31884 5.16955C8.6397 5 9.06005 5 9.90012 5H13.256C13.3479 5 13.4283 5 13.4999 5.00068M17.9992 9.66667C17.9999 9.74103 17.9999 9.82453 17.9999 9.91998V16.5139C17.9999 17.3834 17.9999 17.8181 17.8365 18.1506C17.6927 18.4433 17.4628 18.6815 17.1806 18.8306C16.86 19 16.4406 19 15.6022 19L12.7499 19M17.9992 9.66667C17.9971 9.44462 17.9892 9.30403 17.9581 9.16992C17.9214 9.0112 17.8605 8.85944 17.7783 8.72026C17.6855 8.56328 17.5565 8.42913 17.2971 8.1601L14.953 5.72917C14.6938 5.4603 14.5638 5.32555 14.4125 5.22938C14.2783 5.14409 14.1321 5.08109 13.9791 5.04298C13.8497 5.01077 13.7142 5.0027 13.4999 5.00068M17.9992 9.66667H15.8976C15.0592 9.66667 14.6393 9.66667 14.3188 9.49729C14.0365 9.34815 13.8072 9.10971 13.6634 8.81701C13.4999 8.48426 13.4999 8.04897 13.4999 7.17778V5.00068"
      stroke="#447AED"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default PaymentTaskIcon;
